/* src/app/content-editor/build-versions/build-versions.component.scss */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}
.modal.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.modal-dialog {
  position: relative;
  width: auto;
  margin: 1.75rem auto;
  max-width: 650px;
  pointer-events: none;
}
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
.modal-content .modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-content .modal-header .modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  font-weight: 500;
  font-size: 1.25rem;
}
.modal-content .modal-header .close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  padding: 0;
  background-color: transparent;
  border: 0;
  appearance: none;
  cursor: pointer;
}
.modal-content .modal-header .close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.modal-content .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
  overflow-y: auto;
  max-height: 70vh;
}
.modal-content .modal-body .text-center {
  text-align: center;
}
.modal-content .modal-body .btn {
  margin-left: 5px;
}
.modal-content .modal-body .live {
  background-color: #28a745;
  color: white;
}
.modal-content .modal-body table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
}
.modal-content .modal-body table th,
.modal-content .modal-body table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  text-align: left;
}
.modal-content .modal-body table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.modal-content .modal-body table tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
.modal-content .modal-body table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.modal-content .modal-body table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.15) !important;
}
.modal-content .modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-content .modal-footer .btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  cursor: pointer;
}
.modal-content .modal-footer .btn.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.modal-content .modal-footer .btn.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
/*# sourceMappingURL=build-versions.component.css.map */
